import { Api } from '.'
import store from '../state/store.js'

import { setAreas, setError, setLoading, setSelectedArea } from '../state/parking'

export function fetchAreas (config) {
  store.dispatch(setLoading(true))

  const api = new Api(
    config,
    (response) => {
      store.dispatch(setAreas(response.data))
      store.dispatch(setError(null))
      store.dispatch(setLoading(false))
    },
    (error) => {
      const detail = error?.response?.data?.detail ?? error?.response?.data ?? error?.message ?? 'Unknown error'
      store.dispatch(setError(detail))
      store.dispatch(setLoading(false))
    }
  )

  api.fetch('parking/areas')
}

export function fetchArea (areaId) {
  return (dispatch, getState) => {
    const state = getState()
    const config = state?.config?.config

    dispatch(setLoading(true))

    const api = new Api(
      config,
      (response) => {
        dispatch(setSelectedArea(response.data))
        dispatch(setError(null))
        dispatch(setLoading(false))
      },
      (error) => {
        const detail = error?.response?.data?.detail ?? error?.response?.data ?? error?.message ?? 'Unknown error'
        dispatch(setError(detail))
        dispatch(setLoading(false))
      }
    )

    api.fetch(`parking/areas/${areaId}`)
  }
}
